import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
    fetchPublicacion,
    editPublicacion,
    fetchMarcas,
    fetchCategorias,
    getMarcaById
} from '../../../../actions/publicacionesActions';
import { fetchCategoriaApi, CargarBlisterApi, EliminarBlisterApi, ObtenerBlisterApi } from '../../../../api/axios';
import { DropDownArrow, customStyle } from "../../../../template/CustomStyle";
import DescripcionAmpliada from './DescripcionAmpliada';
import { toast } from '../../../../utilities/appToast';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types'

class DatosBasicos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      marca: { label: '', value: '' },
      categoria: { label: '', value: '' },
      dimensiones: [],
      isCreated: true,
      fetchingCategoria: false,
      fetchingMarca: false,
      showCategoriaChangeModal: false,
      pendingCategoria: null,
      blisterActivo: false,
      archivoBlister: null,
      archivoNombre: null,
    };
    this.tituloInputRef = React.createRef();
  }

  componentDidMount = () => {
    if (this.tituloInputRef.current) {
      this.tituloInputRef.current.focus();
    }

    if (this.props.isEditing) {
      this.handleEditingState();
    } else {
      this.handleNonEditingState();
    }

    //Blister
    this.checkBlister();
  }

  handleEditingState = () => {
    if (this.state.isCreated && this.props.publicacion?.marca && this.props.publicacion?.categoria) {
      this.setMarca(this.props.publicacion.marca);
      this.setCategoria(this.props.publicacion.descripcionCategoria);
    }
  }

  handleNonEditingState = () => {
    if (this.props.publicacion?.marca && this.props.publicacion?.descripcionMarca) {
      this.setState({
        marca: {
          value: this.props.publicacion.marca,
          label: this.props.publicacion.descripcionMarca,
        },
      });
    }

    if (this.props.publicacion?.categoria && this.props.publicacion?.descripcionCategoria) {
      this.setState({
        categoria: {
          value: this.props.publicacion.categoria,
          label: this.props.publicacion.descripcionCategoria,
        },
      });
    }
  }


  componentDidUpdate(prevProps) {
    // Reset explícito
    if (prevProps.resetFlag !== this.props.resetFlag) {
      this.setState({
        marca: { label: '', value: '' },
        categoria: { label: '', value: '' },
      });
    }

    // Solo reaccionamos cuando cambian las props.publicacion (evita loops por setState interno)
    if (this.props.isEditing) {
      if (prevProps.publicacion !== this.props.publicacion) {
        const { publicacion } = this.props;

        // Marca: si viene un id distinto al value actual y no estamos obteniéndola ahora
        if (publicacion?.marca && String(this.state.marca.value) !== String(publicacion.marca) && !this.state.fetchingMarca) {
          this.setMarca(publicacion.marca);
        }

        // Categoria: si viene descripcionCategoria y el label no coincide con el label actual
        if (publicacion?.descripcionCategoria && this.state.categoria.label !== publicacion.descripcionCategoria && !this.state.fetchingCategoria) {
          this.setCategoria(publicacion.descripcionCategoria);
        }
      }
    } else if (this.props.publicacion.categoria !== prevProps.publicacion.categoria && this.props.publicacion.categoria === 0) {
      this.setCategoriaNew();
    }

    //Blister
    if (
      this.props.publicacion?.idPublicacion &&
      this.props.publicacion?.idPublicacion !== prevProps.publicacion?.idPublicacion
    ) {
      this.checkBlister();
    }
  }
    
  setCategoriaNew = () => {
    this.setState({
      marca: null,
      categoria: null,
    });
  }

  setMarca = async (marcaId) => {
    if (!marcaId) {
      toast.error("No se puede obtener la marca");
      return;
    }
    // Lógica para manejar `marcaId` como el valor entero
    try {
      const response = await getMarcaById(marcaId);
      this.setState({
        marca: {
          label: response.marca.descripcion,
          value: response.marca.codigo
        },
        isCreated: false
      });
    } catch (err) {
      if (err.response?.data?.errores) {
        err.response.data.errores.forEach(error => toast.error(error));
      } else {
        toast.error("No se puede obtener la marca");
      }
    }
  }

  setCategoria = (descripcionBuscada) => {
    if (!descripcionBuscada) {
      toast.error("No se puede obtener la categoría");
      return;
    }

    // Protegemos con flag
    this.setState({ fetchingCategoria: true });

    fetchCategoriaApi(descripcionBuscada)
      .then((response) => {
        const lista = response?.categorias ?? response?.elementos ?? response?.elementos?.categorias ?? [];

        // Buscamos coincidencia exacta por descripcion primero
        const exact = lista.find(x => x.descripcion === descripcionBuscada);
        const item = exact || lista[0];

        if (!item) {
          this.setState({ fetchingCategoria: false });
          return;
        }

        // Si ya tenemos la misma etiqueta y el mismo id, no hacemos setState
        if (this.state.categoria.label === item.descripcion && String(this.state.categoria.value) === String(item.id)) {
          this.setState({ fetchingCategoria: false });
          return;
        }

        this.setState({
          categoria: { value: item.id, label: item.descripcion },
          isCreated: false,
          fetchingCategoria: false
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ fetchingCategoria: false });
        toast.error("No se puede obtener la categoría");
      });
  }

  onSelectSearchInputCategorias = (descripcion) => {
    this.props.fetchCategorias(descripcion);
  }

  onSelectSearchInputMarcas = (descripcion) => {
    this.props.fetchMarcas(descripcion);
  }

  myChangeHandler = (event) => {
    const { name, value } = event.target;
    let newValue = (name === "stock") ? Number.parseInt(value) : value;
    let publicacion = { ...this.props.publicacion, [name]: newValue }
    this.props.editPublicacion(publicacion);
  }

  selectSearchHandler = (opt, { name }) => {
    if (!opt) {
      const pub = { ...this.props.publicacion, [name]: null };
      if (name === 'categoria') pub.descripcionCategoria = '';
      if (name === 'marca') pub.descripcionMarca = '';
      this.props.editPublicacion(pub);
      this.setState({ [name]: null });
      return;
    }

    // --- Validación especial para categoría ---
    if (name === 'categoria') {
      const lista = Array.isArray(this.props.listaEstructura)
        ? this.props.listaEstructura
        : this.props.listaEstructura?.listaEstructura;

      const tieneEnDB = (lista || []).some(g =>
        (g.atributosValores || []).some(av => {
          const idValor = av?.valor?.id;
          return idValor !== null && idValor !== undefined && Number(idValor) > 0;
        })
      );

      const pv = this.props.productoValores;
      const tieneEnRedux = pv && Array.isArray(pv.idValor) && pv.idValor.length > 0;

      const debeAdvertir = tieneEnDB || tieneEnRedux;

      if (debeAdvertir) {
        // Guardamos la selección que el usuario intentó hacer
        this.setState({
          showCategoriaChangeModal: true,
          pendingCategoria: { opt, name } // name debería ser 'categoria'
        });
        return;
      }
    }

    // --- Camino normal (sin advertencia) ---
    this.aplicarSeleccion(opt, name);
  }

  aplicarSeleccion = (opt, name) => {
    const id = opt.value ?? opt.codigo ?? opt.id;
    const desc = opt.label ?? opt.descripcion ?? '';
    const label = desc;

    const pub = { ...this.props.publicacion, [name]: id };
    if (name === 'categoria') pub.descripcionCategoria = desc;
    if (name === 'marca') pub.descripcionMarca = desc;

    this.props.editPublicacion(pub);
    this.setState({ [name]: { value: id, label } });
  }



  agregarFila = () => {
    const { dimensiones } = this.props;
    if (dimensiones.length > 0) {
      const ultimaFila = dimensiones[dimensiones.length - 1];

      const filaLlena = Object.values(ultimaFila).some(valor => valor !== 0 && valor !== "");

      if (!filaLlena) {
        toast.error("Debe llenar al menos un valor en la última fila antes de agregar otra.");
        return;
      }
    }

    const nuevasDimensiones = [...dimensiones, { alto: 0, ancho: 0, profundidad: 0, peso: 0 }];
    this.props.editPublicacion({ ...this.props.publicacion, dimensiones: nuevasDimensiones });
  }


  cancelarCambioCategoria = () => {
    this.setState({
      showCategoriaChangeModal: false,
      pendingCategoria: null
    });
  }

  confirmarCambioCategoria = () => {
    const pending = this.state.pendingCategoria;
    if (!pending) {
      this.setState({ showCategoriaChangeModal: false });
      return;
    }

    // 1) Acá limpiás lo que corresponda (redux/state) porque avisaste que se pierde:
    // Ejemplos (ajustá a tus actions reales):
    // this.props.limpiarProductoValores();
    // this.props.limpiarEstructuraAtributos();

    // 2) Aplicás la categoría seleccionada
    this.aplicarSeleccion(pending.opt, pending.name);

    // 3) Cerrás modal y limpiás pending
    this.setState({
      showCategoriaChangeModal: false,
      pendingCategoria: null
    });
  }


  borrarFila = (position) => {
    const nuevasDimensiones = this.props.dimensiones.filter((_, index) => index !== position);
    this.props.editPublicacion({ ...this.props.publicacion, dimensiones: nuevasDimensiones });
  }

  changeSku = (event) => {
    let value = event.target.value;
    if (value.length <= 30) {
      let publicacion = { ...this.props.publicacion };
      publicacion[event.target.name] = event.target.value;
      this.props.editPublicacion(publicacion);
    }
  }

  changeDimensionFormat = (num) => {
    let formatted = num.replace(/^(\d{3})(\d)/, '$1.$2');
    return formatted.substring(0, 6);
  }

  changeDimensions = (event) => {
    const { name, value } = event.target;
    let valor = this.changeDimensionFormat(value);
    let index = Number.parseInt(name.replaceAll(/\D/g, ""), 10);
    let nuevasDimensiones = [...(this.props.dimensiones || [])];

    if (!nuevasDimensiones[index]) {
      nuevasDimensiones[index] = { alto: 0, ancho: 0, profundidad: 0, peso: 0 };
    }

    if (name.includes("alto")) nuevasDimensiones[index].alto = valor;
    if (name.includes("ancho")) nuevasDimensiones[index].ancho = valor;
    if (name.includes("profundidad")) nuevasDimensiones[index].profundidad = valor;
    if (name.includes("peso")) nuevasDimensiones[index].peso = valor;

    this.props.editPublicacion({
      ...this.props.publicacion,
      dimensiones: nuevasDimensiones
    });
  }

  handleBlisterChange = (e) => {
    const checked = e.target.checked;

    this.setState({ blisterActivo: checked });

    if (!checked) {
      // Si lo apaga → eliminar blister
      const id = this.props.publicacion?.idPublicacion;
      this.setState({
        archivoBlister: null,
        archivoNombre: null
      });

      if (id) {
        EliminarBlisterApi(id)
          .then(() => {
            if (this.canManageBlister()) {
              toast.success("Blister eliminado");
            }
          })
          .catch(err => {
            if (this.canManageBlister()) {
              const msg = err?.response?.data?.errorMesage || "Error al eliminar";
              toast.error(msg);
            }
          });
      }
    }
  }

  handleFile = (file) => {
    if (!file) return;

    if (file.type !== "application/pdf") {
      toast.error("Solo se permiten PDF");
      return;
    }

    const reader = new FileReader();

    reader.onload = async () => {
      const base64 = reader.result.split(',')[1];
      const id = this.props.publicacion?.idPublicacion;

      try {
        await CargarBlisterApi(id, { archivo: base64 });
        if (this.canManageBlister()) {
          toast.success("Blister cargado correctamente");
        }

        this.setState({
          archivoBlister: base64,
          blisterActivo: true,
          archivoNombre: file.name,
        });
      } catch (error) {
        if (this.canManageBlister()) {
          const msg = error?.response?.data?.errorMesage || "Error al cargar";
          toast.error(msg);
        }
      }
    };

    reader.readAsDataURL(file);
  }

  checkBlister = async () => {
    const id = this.props.publicacion?.idPublicacion;

    if (!id) return;

    try {
      const res = await ObtenerBlisterApi(id);

      this.setState({
        blisterActivo: true,
        archivoBlister: res?.archivo || null,
      });

    } catch (error) {
      this.setState({
        blisterActivo: false
      });
    }
  }

  canManageBlister = () => {
    const { userType } = this.props;
    return userType?.isCategory || userType?.isAdminMod;
  }

  render() {
    const { userType } = this.props;

    return (
      <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="form-group">
              <label htmlFor="nombreProductoDatosBasicos">Nombre Producto</label>
              <input
                id="nombreProductoDatosBasicos"
                type="text"
                className="form-control"
                value={this.props.publicacion.titulo || ''}
                onChange={this.myChangeHandler}
                name="titulo"
                ref={this.props.tituloRef}
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="eanDatosBasicos">EAN</label>
              <input
                id="eanDatosBasicos"
                className="form-control"
                name="ean"
                value={this.props.publicacion.ean}
                onChange={this.myChangeHandler}
                type="text"
                min="0"
                maxLength="50"
              />
            </div>

            <div>
              <label htmlFor="categoriaDatosBasicos">Categoria</label>
              <Select
                id="categoriaDatosBasicos"
                name="categoria"
                value={this.state.categoria}
                options={this.props.categorias}
                placeholder="Seleccione una categoria..."
                onChange={(option) => this.selectSearchHandler(option, { name: 'categoria' })}
                onInputChange={this.onSelectSearchInputCategorias}
                onMenuOpen={() => this.props.fetchCategorias("")}
                styles={customStyle}
                components={{ DropdownIndicator: () => DropDownArrow }}
                getOptionValue={(o) => String(o.value ?? o.codigo ?? o.id)}
                getOptionLabel={(o) => `${(o.label ?? o.descripcion) ?? ''} (${String(o.value ?? o.codigo ?? o.id)})`}
              />
            </div>

            <div>
              <label htmlFor="marcaDatosBasicos">Marca</label>
              <Select
                id="marcaDatosBasicos"
                name="marca"
                value={this.state.marca}
                options={this.props.marcas}
                placeholder="Seleccione una marca..."
                onChange={(option) => this.selectSearchHandler(option, { name: 'marca' })}
                onInputChange={this.onSelectSearchInputMarcas}
                onMenuOpen={() => this.props.fetchMarcas("")}
                styles={customStyle}
                components={{ DropdownIndicator: () => DropDownArrow }}
                className={"form-material"}
                getOptionValue={(o) => String(o.value ?? o.codigo ?? o.id)}
                getOptionLabel={(o) => `${(o.label ?? o.descripcion) ?? ''} (${String(o.value ?? o.codigo ?? o.id)})`}
              />
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="form-group">
              <label htmlFor="stockDatosBasicos">Stock</label>
              <input
                id="stockDatosBasicos"
                className="form-control"
                value={this.props.publicacion.stock}
                onChange={this.myChangeHandler}
                name="stock"
                max="9999"
                min="0"
                type="number"
                onInput={(e) => {
                  const value = e.target.value;
                  if (value.length > 4) {
                    e.target.value = value.slice(0, 4);
                  }
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="skuSellerDatosBasicos">SKU Seller</label>
              <input
                id="skuSellerDatosBasicos"
                className="form-control"
                name="skuSeller"
                value={this.props.publicacion.skuSeller}
                onChange={this.changeSku}
              />
            </div>

            <div className="form-group">
              <label htmlFor="skuMarketDatosBasicos">Sku Market</label>
              <input
                id="skuMarketDatosBasicos"
                type="text"
                className="form-control"
                value={this.props.publicacion.skuMarket}
                name="skuMarket"
                disabled
              />
            </div>

            {userType.isCategory || userType.isAdminMod &&
              <div className="form-group">
                <div className="form-check form-switch d-flex align-items-center gap-2">
                  <label htmlFor="blister" className="mb-0 me-1">
                    Blister
                  </label>
                  <input
                    type="checkbox"
                    id="blister"
                    className="form-check-input"
                    onChange={this.handleBlisterChange}
                    checked={this.state.blisterActivo}
                  />

                  {/* Si hay PDF cargado */}
                  {this.state.archivoBlister ? (
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                      <span style={{ fontSize: "12px", color: "green" }}>
                        ✔ PDF cargado
                      </span>

                      {this.state.archivoNombre && (
                        <span style={{ fontSize: "12px" }}>
                          📄 {this.state.archivoNombre}
                        </span>
                      )}
                    </div>
                  ) : (
                    /* Si NO hay PDF y el toggle está activo */
                    this.state.blisterActivo && (
                      <div className="d-flex align-items-center">
                        <div
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault();
                            const file = e.dataTransfer.files[0];
                            this.handleFile(file);
                          }}
                          onClick={() => this.fileInputRef.click()}
                          style={{
                            border: "2px dashed #007bff",
                            borderRadius: "8px",
                            padding: "5px",
                            textAlign: "center",
                            background: "#f8f9fa",
                            cursor: "pointer"
                          }}
                        >
                          📄 Arrastrá el PDF acá o hacé click
                        </div>

                        <input
                          type="file"
                          accept="application/pdf"
                          style={{ display: "none" }}
                          ref={(ref) => (this.fileInputRef = ref)}
                          onChange={(e) => {
                            this.handleFile(e.target.files[0]);
                            e.target.value = null;
                          }}
                        />

                        {this.state.archivoNombre && (
                          <div style={{ marginLeft: "10px", fontSize: "12px" }}>
                            📄 {this.state.archivoNombre}
                          </div>
                        )}
                      </div>
                    )
                  )}
                </div>
              </div>
            }
          </div>

          <div className="col-12 table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Alto (cm)</th>
                  <th>Ancho (cm)</th>
                  <th>Profundidad (cm)</th>
                  <th>Peso (kg)</th>
                  <th>
                    <button type="button" onClick={this.agregarFila} style={{ border: "none", background: "none" }}>
                      <i className="fas fa-plus" />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props?.dimensiones?.map((item, numeroFila) => {
                  return (
                    <tr className="hover-background-color" key={numeroFila}>
                      <td>
                        <input
                          className="form-control"
                          name={"alto" + numeroFila}
                          value={item.alto}
                          type="number"
                          min="0"
                          step="any"
                          onChange={this.changeDimensions}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          name={"ancho" + numeroFila}
                          value={item.ancho}
                          type="number"
                          min="0"
                          step="any"
                          onChange={this.changeDimensions}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          name={"profundidad" + numeroFila}
                          value={item.profundidad}
                          type="number"
                          min="0"
                          step="any"
                          onChange={this.changeDimensions}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          name={"peso" + numeroFila}
                          value={item.peso}
                          type="number"
                          min="0"
                          step="any"
                          onChange={this.changeDimensions}
                        />
                      </td>
                      <td onClick={() => this.borrarFila(numeroFila)} style={{ cursor: 'pointer' }}>
                        <i className="fas fa-trash-alt" />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="form-group my-4">
          <label>Descripción Ampliada</label>
          <DescripcionAmpliada />
        </div>


        <Modal
          show={this.state.showCategoriaChangeModal}
          onHide={this.cancelarCambioCategoria}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmar cambio</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            Al cambiar la categoría perderás los atributos y valores cargados en Caracteristicas. ¿Deseas continuar?
          </Modal.Body>

          <Modal.Footer>
            <button type="button" className="btn btn-sm btn-light" onClick={this.cancelarCambioCategoria}>
              Cancelar
            </button>
            <button type="button" className="btn btn-sm btn-grey" onClick={this.confirmarCambioCategoria}>
              Confirmar
            </button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}
DatosBasicos.propTypes = {
  // Redux props
  tituloRef: PropTypes.string,
  isEditing: PropTypes.bool,
  publicacion: PropTypes.shape({
    marca: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    categoria: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    descripcionCategoria: PropTypes.string,
    descripcionMarca: PropTypes.string,
    titulo: PropTypes.string,
    ean: PropTypes.string,
    stock: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    skuSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    skuMarket: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  listaEstructura: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
    listaEstructura: PropTypes.array,
  })]),
  productoValores: PropTypes.shape({
    idValor: PropTypes.array,
  }),
  dimensiones: PropTypes.arrayOf(PropTypes.shape({
    alto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ancho: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    profundidad: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    peso: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  })),
  categorias: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
    categorias: PropTypes.array,
  })]),
  marcas: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
    marcas: PropTypes.array,
  })]),
  // Actions props
  resetFlag: PropTypes.func,
  fetchCategorias: PropTypes.func,
  fetchMarcas: PropTypes.func,
  editPublicacion: PropTypes.func,
  userType: PropTypes.shape({
    isCategory: PropTypes.bool,
    isAdminMod: PropTypes.bool,
  }),
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    dimensiones: state.publicaciones.dimensiones,
    categorias: state.publicaciones.categorias,
    marcas: state.publicaciones.marcas,
    productoValores: state.publicaciones.productoValores,
    listaEstructura: state.publicaciones.listaEstructura,
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    editPublicacion,
    fetchMarcas,
    fetchCategorias,
})(DatosBasicos);
